<div class="interests-wrapper">
  <section class="front-page">
    <div class="int-header">
      <span class="front-header text-right">My Interest</span>
    </div>
    <div class="int-content">
      <h3 class="front-header">Here my Interest are introduced from travelling to coding</h3>
    </div>
  </section>

  <section class="red">
    <div class="int-header">
      <span class="text-right">My Interest</span>
    </div>
    <div class="int-content">
      <span>Here my Interest are introduced from travelling to coding</span>
    </div>
  </section>

  <section class="green">
    <div class="int-header">
      <span class="text-right">My Interest</span>
    </div>
    <div class="int-content">
      <span>Here my Interest are introduced from travelling to coding</span>
    </div>
  </section>

</div>
